<template>
  <layout-workflow>
    <v-layout column align-center>
      <v-flex data-e2e-id="no-membership-alert">
        <h2 class="pt-5">Welcome to the Paradigm Health Platform</h2>
        <p class="subheading">
          Your account does not yet have access to your institution’s resources in our system.
          Please contact your site's Access Manager or Paradigm Health Support at
          <a class="viper-link" href="mailto:support@paradigm.inc">support@paradigm.inc</a> to request
          the necessary permissions.
        </p>
      </v-flex>
    </v-layout>
  </layout-workflow>
</template>

<script>
import LayoutWorkflow from '@/components/layout/LayoutWorkflow'
import { MyActiveRoles } from '@/helpers/my-account-helper'
import _ from 'lodash'

export default {
  components: { LayoutWorkflow },
  mounted() {
    const refresh = setInterval(() => window.location.reload(), 60000)
    if (!_.isEmpty(MyActiveRoles)) {
      clearInterval(refresh)
      this.$router.push({ name: 'home' })
    }
  }
}
</script>
